import { AsyncThunkAction } from "@reduxjs/toolkit";

export enum passwordFormModes {
  set = "set",
  change = "change",
  reset = "reset",
}

export type CommonAsyncThunkAction = AsyncThunkAction<void, any, {}>;
